import actions from '../actions';
import { ReducerBuilder } from './reducer-builder';

const defaultState = {
  rehydrated: false,
  justSubmitted: false,
  showPasswordlessLogin: false,
  email: '',
  emailAlreadyExist: false,
  linkSentToEmail: false,
  sendLoginLinkError: null,
  loginLinkStatus: null,
  checkingLoginLinkStatus: false
};

const reducer = new ReducerBuilder(defaultState)
  .handle(actions.app.temporary.rehydrated, (state, _) => ({
    ...state,
    rehydrated: true
  }))
  .handle(actions.app.temporary.showPasswordlessLogin, (state, action) => ({
    ...state,
    showPasswordlessLogin: action.payload.show
  }))
  .handle(actions.app.temporary.changeEmail, (state, action) => ({
    ...state,
    email: action.payload.email,
    emailAlreadyExist: false,
    sendLoginLinkError: null
  }))
  .handle(actions.app.temporary.setEmailAlreadyExist, (state, action) => ({
    ...state,
    emailAlreadyExist: true
  }))
  .handle(actions.app.temporary.linkSentToEmail, (state, action) => ({
    ...state,
    linkSentToEmail: action.payload.sent,
    sendLoginLinkError: null
  }))
  .handle(actions.app.temporary.justSubmitted, (state, _) => ({
    ...state,
    justSubmitted: true
  }))
  .handle(actions.app.temporary.sendLoginLinkFailure, (state, action) => ({
    ...state,
    sendLoginLinkError: action.payload.error,
    linkSentToEmail: false
  }))
  .handle(actions.app.temporary.checkLoginLinkStatus, (state, action) => ({
    ...state,
    checkingLoginLinkStatus: true,
    sendLoginLinkError: null
  }))
  .handle(actions.app.temporary.checkLoginLinkStatusSuccess, (state, action) => ({
    ...state,
    loginLinkStatus: action.payload.status,
    checkingLoginLinkStatus: false
  }))
  .handle(actions.app.temporary.checkLoginLinkStatusFailure, (state, action) => ({
    ...state,
    sendLoginLinkError: action.payload.error,
    checkingLoginLinkStatus: false
  }))
  .handle(actions.app.auth.logoutSuccess, (state) => ({
    ...state,
    justSubmitted: false,
    showPasswordlessLogin: false,
    linkSentToEmail: false,
    sendLoginLinkError: null,
    loginLinkStatus: null,
    checkingLoginLinkStatus: false
  }))
  .done();

export default reducer;